import React from "react";
import numeral from "numeral";
import moment from "moment";

import styles from "./style.module.css";

export default class DatasetSchemaChanges extends React.PureComponent {
  render() {
    const { linkedSchemaChanges } = this.props;
    return (
      <React.Fragment>
        {linkedSchemaChanges.table ? (
          <React.Fragment>
            <div className={styles.schemaChangeMsgTitle}>{"Table Changes"}</div>
            {linkedSchemaChanges.table.map((elem, i) => (
              <div className={styles.schemaItem} key={"table " + elem.name + " " + i}>
                {elem.delta}
              </div>
            ))}
          </React.Fragment>
        ) : (
          ""
        )}
        {linkedSchemaChanges.columns ? (
          <React.Fragment>
            <div className={styles.schemaChangeMsgTitle}>{"Column Changes"}</div>
            <div className={styles.schemaChangeTable}>
              <div className={styles.schemaRow + " " + styles.isHeader}>
                <div className={styles.schemaCol}>{"Column"}</div>
                <div className={styles.schemaCol}>{"Change"}</div>
              </div>
              {linkedSchemaChanges.columns.map((elem, i) => (
                <div className={styles.schemaRow} key={"column " + elem.name + " " + i}>
                  <div className={styles.schemaCol} title={elem.name}>
                    {elem.name}
                  </div>
                  <div className={styles.schemaCol} title={elem.delta}>
                    {elem.delta}
                  </div>
                </div>
              ))}
            </div>
          </React.Fragment>
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }
}
